<template>
    <MainContentSearchable title="Listado de deportistas" id="bases" v-model="filters" :meta="loading ? {} : bases.meta" @updated="debouncedGetBases">
        <template v-slot:header>
            <b-row class="mr-0 pr-0">
                <b-col cols="12" class="mb-3 mr-0 pr-0" >
                    <SelectListaComponent
                        v-model="lista_abonados"
                        @input="cambiarListaAbonados"
                    />
                </b-col>
                <b-col cols="12" md="5" class="mb-3 mr-0">
                    <router-link :to="{ name: 'back.bases.informe', params: { lista_id: lista_abonados.id } }" class="btn btn-primary ml-0" target="blank"><i class="fas fa-chart-bar mr-1"></i>VENTAS</router-link>
                    <router-link :to="{ name: 'back.bases.categorias.index', params: { lista_id: lista_abonados.id } }" class="btn btn-primary ml-2" target="blank">Configurar precios categorías</router-link>
                </b-col>
                <b-col cols="12" md="7" class="mb-3 mr-0 pr-0">
                    <hr />
                    <router-link :to="{ name: 'back.bases.equipos', params: { lista_id: lista_abonados.id } }" class="btn btn-primary mr-2" target="blank">Equipos</router-link>
                    <router-link :to="{ name: 'back.bases.indumentarias.index', params: { lista_id: lista_abonados.id } }" class="btn btn-primary mr-2" target="blank">Configurar indumentarias</router-link>
                    <router-link :to="{ name: 'back.bases.renovar', params: { lista_id: lista_abonados.id } }" class="btn btn-primary mr-2" target="blank">Renovar deportista</router-link>
                    <router-link :to="{ name: 'back.bases.crear', params: { lista_id: lista_abonados.id } }" class="btn btn-primary mr-0" target="blank">Nuevo deportista</router-link>
                    <router-link :to="{ name: 'back.bases.fields', params: { lista_id: lista_abonados.id } }" class="btn btn-primary mr-0" target="blank" data-cy="campos-personalizados">Campos personalizados</router-link>
                </b-col>
            </b-row>
        </template>
        <template v-slot:extra-options>
            <div class="col-12 col-lg-9">
                <div class="input-group-sm my-3" >
                    <select class="custom-select w-auto mr-3 mar-opt" id="search" v-model="filters.search_for" @change="debouncedGetBases()">
                        <option value="">Buscar por</option>
                        <option value="nombre">Nombre</option>
                        <option value="apellidos">Apellidos</option>
                        <option value="dni">DNI</option>
                        <option value="email">Email</option>
                        <option value="dni_responsable">DNI responsable</option>
                        <option value="email_responsable">Email responsable</option>
                    </select>

                    <select class="custom-select w-auto mr-3 mar-opt" id="categorias" v-model="filters.categoria" @change="debouncedGetBases()">
                        <option value="">Categorias</option>
                        <option v-for="categoria in categorias" :value="categoria.id" :key="categoria.id">{{categoria.name}}</option>
                    </select>

                    <select class="custom-select w-auto mr-3 mar-opt" id="pago" v-model="filters.metodo_pago" @change="debouncedGetBases()">
                        <option value="">Método Pago</option>
                        <option value="1">Metálico</option>
                        <option value="3">Tarjeta</option>
                        <option value="4">Transferencia</option>
                        <option value="7">Domiciliación</option>
                    </select>

                    <select class="custom-select w-auto mr-3 mar-opt" id="equipos" v-model="filters.equipo" @change="debouncedGetBases()">
                        <option value="">Equipos</option>
                        <option v-for="equipo in equipos" :value="equipo.id" :key="equipo.id">{{equipo.nombre}}</option>
                    </select>
                </div>
            </div>
        </template>
        <template v-slot:content>
            <div v-if="!loading">
                <ListadoDeportistas :bases="bases" :lista_id="lista_abonados.id" @actualizado="debouncedGetBases"/>
            </div>
            <LoaderComponent v-else/>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import ListadoDeportistas from "./components/ListadoDeportistas";
    import SelectListaComponent from "@/components/backend/components/listas_abonados/SelectListaComponent.vue";

    export default {
        data() {
            return {
                bases: { data: [], meta: { current_page: 1 } },
                categorias: [],
                loading: false,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                    search_for: "",
                    categoria: '',
                    metodo_pago: '',
                    equipo: ''

                },
                equipos: [],
                lista_abonados: null
            }
        },
        created() {
            this.lista_abonados = this.$store.getters.getListaActiva;
            this.getCategorias();
            this.getEquipos();
            this.getBases();
            this.debouncedGetBases = _.debounce(this.getBases, 500)
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            url_descarga_informe() {
                return this.config.API_BASE + '/bases/informe?api_key=' + localStorage.getItem('token');
            }
        },
        methods: {
            getBases() {
                this.loading = true;

                let params = {
                    filters: this.filters,
                    lista_id: this.lista_abonados.id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.bases.index'), params).then(res => {
                    this.bases = res.data;
                }).finally(() => this.loading = false);
            },
            getCategorias(){
                let params = {
                    filters: {},
                    lista_id: this.lista_abonados.id
                }
                this.$store.dispatch(this.config.getVuexAlias('back.bases.get.categorias'), params).then(res => {
                    this.categorias = res.data.data;
                });
            },
            getEquipos(){
                let params = {
                    filters: {},
                    lista_id: this.lista_abonados.id
                }
                this.$store.dispatch(this.config.getVuexAlias('back.bases.get.equipos'), params).then(res => {
                    this.equipos = res.data.data;
                });
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            cambiarListaAbonados() {
                this.$router.push({ name: 'back.bases.index', params: { lista_id: this.lista_abonados.id } });
                this.getBases();
            },
        },
        components: {
            MainContentSearchable, ListadoDeportistas, SelectListaComponent
        }
    }
</script>

<style scoped>
    .col-sp-5 {
        -ms-flex: 0 0 41.666667%;
        flex: 0 0 41.666667%;
        max-width: 41.666667%;
    }

    .col-sp-7 {
        -ms-flex: 0 0 58.333333%;
        flex: 0 0 58.333333%;
        max-width: 58.333333%;
    }

    hr {
        display: none;
    }

    .btn {
        margin: 5px;
    }

    @media (max-width: 768px) {
        .org-but {
            align-items: center;
            justify-content: center;
        }

        .btn {
            margin: 3px;
        }

        .col-sp-5 {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
        }

        .col-sp-7 {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
        }

        hr {
            display: block;
            border: 1px solid #ececec;
            margin-top: 0px;
        }

        .mar-opt {
            margin-top: 5px;
            margin-bottom: 5px;
        }
    }
</style>
